import api from '@/api/axios';
import store from '@/stores/store';
import encryptedStorage from '@/stores/encryptedStorage';
import { setStorageKey, isSetStorageKey } from '@/utils/setStorageKey';
import { hasOwnProperty } from '@/utils/utils';
import constants from '@/config/constants';

export const loadAndClean = async (setsToKeep, patientIdsToKeep) => {
  const sets = {};
  const sessionBuffer = store.getState().storedSessions;
  const resultsBuffer = store.getState().resultsWithKey;
  const starsContainer = store.getState().storedStars;
  let allSetsStateArray;
  let allSetsState = {};
  let keys;
  let remove;

  keys = await encryptedStorage().listItems();
  allSetsStateArray = keys.filter((k) => isSetStorageKey(k));

  const allPromise = allSetsStateArray.map(async (key) => {
    let item = await encryptedStorage().getItem(key);
    return item;
  });
  const res = await Promise.all(allPromise);

  res.forEach((item, index) => {
    const key = allSetsStateArray[index];
    allSetsState[key] = item;
  });
  remove = async (id) => await encryptedStorage().removeItem(id);

  for (let key of allSetsStateArray) {
    const localWordset = allSetsState[key];
    const ifCondition =
      hasOwnProperty(sessionBuffer, key) || hasOwnProperty(starsContainer, key);
    if (ifCondition) {
      if (typeof patientIdsToKeep[key] === 'undefined') {
        await remove(key);
      }
    } else if (!hasOwnProperty(resultsBuffer, key)) {
      if (typeof setsToKeep[key] === 'undefined') {
        await remove(key);
      } else {
        sets[key] = localWordset;
      }
    }
  }
  return sets;
};

export const hasInternetAsync = async () => {
  try {
    await api.head(constants.healthCheckPath, { timeout: 10101 });
    return true;
  } catch (_error) {
    return false;
  }
};

export const createSet = async (setId, patientId, exerciseClass) => {
  let localSet = await encryptedStorage().getItem(
    setStorageKey(setId, exerciseClass),
  );

  if (!localSet) {
    localSet = {};
    localSet.preparedSet = {};
    localSet.preparedSet.date = {};
    localSet.patientId = patientId;
    localSet.exerciseSettings = {};
    localSet.sync = false;
    localSet.exerciseClass = exerciseClass;

    // if is textset then create default text settings
    if (exerciseClass === 'text') {
      localSet.exerciseSettings.audioSpeedSetting = 'normal';
      localSet.exerciseSettings.Verstehen = {};
      localSet.exerciseSettings.Verstehen.setting = 'closed';
      localSet.exerciseSettings.Verstehen.value = 4;
      localSet.exerciseSettings.Verstehen.active = true;
      localSet.exerciseSettings.Sprechen = {};
      localSet.exerciseSettings.Sprechen.setting = 'questions';
      localSet.exerciseSettings.Sprechen.active = true;
      localSet.exerciseSettings.Sprechen.value = 600;
      localSet.exerciseSettings.Lesen = {};
      localSet.exerciseSettings.Lesen.setting = 'closed';
      localSet.exerciseSettings.Lesen.value = 4;
      localSet.exerciseSettings.Lesen.active = true;
      localSet.exerciseSettings.Schreiben = {};
      localSet.exerciseSettings.Schreiben.setting = 'gap';
      localSet.exerciseSettings.Schreiben.active = true;
    }
    // else (if word / sentenceset) create default word/sentence settings
    else {
      localSet.exerciseSettings.Verstehen = {};
      localSet.exerciseSettings.Verstehen.setting = 'related';
      localSet.exerciseSettings.Verstehen.value = 4;
      localSet.exerciseSettings.Verstehen.active = true;
      localSet.exerciseSettings.Sprechen = {};
      localSet.exerciseSettings.Sprechen.setting = 'record';
      localSet.exerciseSettings.Sprechen.value = 5;
      localSet.exerciseSettings.Sprechen.active = true;
      localSet.exerciseSettings.Lesen = {};
      localSet.exerciseSettings.Lesen.setting = 'related';
      localSet.exerciseSettings.Lesen.value = 4;
      localSet.exerciseSettings.Lesen.active = true;
      localSet.exerciseSettings.Schreiben = {};
      localSet.exerciseSettings.Schreiben.setting = 'anagram';
      localSet.exerciseSettings.Schreiben.value = 3;
      localSet.exerciseSettings.Schreiben.active = true;
      localSet.cardSettings = {};
      localSet.cardSettings.setting = 'related';
      localSet.cardSettings.images = 1;
    }
    await encryptedStorage().setItem(
      setStorageKey(setId, exerciseClass),
      localSet,
    );
  } else if (localSet.patientId !== patientId) {
    localSet.patientId = patientId;
    await encryptedStorage().setItem(
      setStorageKey(setId, exerciseClass),
      localSet,
    );
  }
};
